/*=========================================================================================
  File Name: actions.js
  Description: Vuex Store - actions
  ----------------------------------------------------------------------------------------
  Item Name: Pre-Pulse
  
==========================================================================================*/
import axios from '../../axios.js'
import router from '../../router.js'
import jwtDecode from 'jwt-decode'
const moment = require('moment') // require
const clonedeep = require('lodash.clonedeep')

const actions = {
  ActionGetTasks({state, commit, dispatch}){
    return new Promise((resolve, reject) => {
      axios.get('pulse/task')
        .then(response => {
          console.log("Task response: ", response.data)
          commit("SetTaskList", response.data.oData)
          resolve(response)
        })
        .catch(error => {
          dispatch("ActionCheckError", error, { root: true })
          reject(error)
        })
    })
  },

  ActionGetIncident({state, commit, dispatch}, payload){
    
    return new Promise((resolve, reject) => {
      axios.get('pulse/incident?IncidentID=' + payload.IncidentID + "&ClientClaimNum=" + payload.ClientClaimNum)
        .then(response => {
          console.log("Incident data ", response.data)
          commit("SetIncident", response.data.oData)
          commit("SetCurrentIncidentID", response.data.oData.IncidentID.toString())
          dispatch("ActionGetIncidentClaims", response.data.oData.IncidentID).then(x => {
            resolve(response.data.oData)
          })
          
        })
        .catch(error => {
          dispatch("ActionCheckError", error, { root: true })
          reject(error)
        })
    })

    
    // return Promise.all([p1]).then((values) => {
    //   console.log("promise all values", values)
    //   router.push("/pulse/claim-auto")
    // })

    // this.$store.commit("pulse/SetCurrentIncidentID", response.data.oData.IncidentID.toString())
    // this.$router.push("/pulse/claim-auto")

  },

  ActionSaveIncident({state, commit, dispatch}, payload){
    return new Promise((resolve, reject) => {
      axios.post('pulse/incident', payload)
        .then(response => {
          console.log("Incident save data ", response.data)
          resolve(response)
        })
        .catch(error => {
          dispatch("ActionCheckError", error, { root: true })
          reject(error)
        })
    })
  },

  ActionGetIncidentClaims({state, commit, dispatch}, payload){
    console.log("Get incident claims")
    return new Promise((resolve, reject) => {
      axios.get('pulse/claim?IncidentID=' + payload)
        .then(response => {
          console.log("Incident claims ", response.data)
          commit("SetIncidentClaims", {claims: response.data.oData, incidentID: payload.toString()})
          resolve(response)
        })
        .catch(error => {
          dispatch("ActionCheckError", error, { root: true })
          reject(error)
        })
    })
  },
  
  ActionSaveIncidentClaim({state, commit, dispatch}, payload){
    return new Promise((resolve, reject) => {
      axios.post('pulse/claim', payload)
        .then(response => {
          console.log("Incident claim create response ", response.data)
          // dispatch("ActionGetIncidentClaims", payload.IncidentID)
          resolve(response)
        })
        .catch(error => {
          dispatch("ActionCheckError", error, { root: true })
          reject(error)
        })
    })
  },
  
  ActionGetClaimLossPayments({state, commit, dispatch}, payload){
    console.log("Get all claim loss payments")
    return new Promise((resolve, reject) => {
      axios.get('pulse/claim/losspayments?ClaimID=' + payload)
        .then(response => {
          console.log("Claim loss payments ", response.data)
          commit("SetClaimLossPayments", response.data.oData)
          resolve(response)
        })
        .catch(error => {
          dispatch("ActionCheckError", error, { root: true })
          reject(error)
        })
    })
  },

  ActionGetCallList({state, commit, dispatch}){
    
    return new Promise((resolve, reject) => {
      axios.get('pulse/claim/calllist')
        .then(response => {
          console.log("Call list ", response.data)
          commit("SetCallList", response.data.oData)
          resolve(response)
        })
        .catch(error => {
          dispatch("ActionCheckError", error, { root: true })
          reject(error)
        })
    })
  },

  ActionSendTask({state, commit, dispatch}, payload){
    return new Promise((resolve, reject) => {
      axios.post('pulse/task/send', payload)
        .then(response => {
          console.log("Created task response ", response.data)
          dispatch("ActionGetTasks")
          resolve(response)
        })
        .catch(error => {
          dispatch("ActionCheckError", error, { root: true })
          reject(error)
        })
    })
  },

  ActionCreateTask({state, commit, dispatch}, payload){
    
    console.log("Create task request", payload)
    return new Promise((resolve, reject) => {
      axios.post('pulse/task/', payload)
        .then(response => {
          console.log("Created task response ", response.data)
          dispatch("ActionGetTasks")
          resolve(response)
        })
        .catch(error => {
          dispatch("ActionCheckError", error, { root: true })
          reject(error)
        })
    })
  },

  ActionAttachedFiles({state, commit, dispatch}, payload){
    
    console.log("Get attached files", payload)
    return new Promise((resolve, reject) => {
      axios.get('pulse/file?IncidentID='+payload)
        .then(response => {
          console.log("Got attached files ", response.data)
          commit("SetAttachedFiles", response.data.oData)
          resolve(response)
        })
        .catch(error => {
          dispatch("ActionCheckError", error, { root: true })
          reject(error)
        })
    })
  },

  ActionFileUploadSettings({state, commit, dispatch}){
    
    console.log("Get file upload settings")
    return new Promise((resolve, reject) => {
      axios.get('pulse/file/settings')
        .then(response => {
          console.log("Got file upload settings ", response.data)
          commit("SetFileUploadSettings", response.data.oData)
          resolve(response)
        })
        .catch(error => {
          dispatch("ActionCheckError", error, { root: true })
          reject(error)
        })
    })
  },

  ActionAddFileToUploadQueue({state, commit, dispatch}, payload){
    console.log("Add file to upload queue")
    return new Promise((resolve, reject) => {
      commit("AddFileToUploadQueue", payload)
      resolve(payload)
    })
  },

  ActionSetFileUploadStatus({state, commit, dispatch}, payload){
    console.log("Update file upload status")
    return new Promise((resolve, reject) => {
      commit("SetFileUploadStatus", payload)
      resolve(payload)
    })
  },

  ActionClaimSearch({state, commit, dispatch}, payload){
    const nonNullObject = Object.fromEntries(Object.entries(payload).filter(([_, v]) => v != null && v != '<none selected>' && v != ''));
    const q = new URLSearchParams(nonNullObject).toString()
    return new Promise((resolve, reject) => {
      axios.get(`pulse/claim/search?${q}`)
        .then(response => {
          commit('SetClaimSearchMax', response.data.oData2)
          commit('SetClaimSearch', response.data.oData)
          console.log("claim search: ", response.data)
          resolve(response)
        })
        .catch(error => {
          dispatch("ActionCheckError", error, { root: true })
          reject(error)
        })
    })
  },


  ActionGetIncidentNotes({state, commit, dispatch}, payload){
    console.log("Get incident notes")
    return new Promise((resolve, reject) => {
      axios.get(`pulse/incident/note?IncidentID=${payload.IncidentID}`)
        .then(response => {
          console.log("Got incident notes", response.data)
          commit("SetIncidentNotes", response.data.oData)
          resolve(response)
        })
        .catch(error => {
          dispatch("ActionCheckError", error, { root: true })
          reject(error)
        })
    })
  },
  ActionSaveIncidentNote({state, commit, dispatch}, payload){
    console.log("Save incident note")
    return new Promise((resolve, reject) => {
      axios.post(`pulse/incident/note`, payload)
        .then(response => {
          console.log("Saved incident note", response.data)
          resolve(response)
        })
        .catch(error => {
          dispatch("ActionCheckError", error, { root: true })
          reject(error)
        })
    })
  },
}

export default actions
